import { Save, Download, UserPlus, Loader2, ShoppingCart } from "lucide-react";
import { Switch } from "../ui/switch";
import { WhatsAppShareButton } from "../WhatsAppShare";

const Spin = ({ on, Icon }) => (on ? <Loader2 className="h-4 w-4 animate-spin" /> : <Icon className="h-4 w-4" />);

export const ActionBar = ({ prefix, onSave, onDownload, onAnother, onOrder, saving, downloading, ordering, guide, onGuide, compact, getSvg, playerName }) => {
  const pad = compact ? "min-w-0 flex-col gap-0.5 overflow-hidden px-0.5 py-1.5 text-[11px] leading-none [&>span]:max-w-full [&>span]:break-all" : "gap-2 px-4 py-2.5 text-sm";
  return (
    <div className={compact ? "grid grid-cols-5 gap-1.5" : "flex flex-wrap items-center gap-2"} data-testid={`${prefix}-action-bar`}>
      <button type="button" onClick={onOrder} disabled={ordering} data-testid={`${prefix}-order-button`} className={`btn-blaze flex items-center justify-center ${pad}`}>
        <Spin on={ordering} Icon={ShoppingCart} /> <span>{compact ? "Order" : "Order shield"}</span>
      </button>
      <button type="button" onClick={onSave} disabled={saving} data-testid={`${prefix}-save-draft-button`}
        className={`flex items-center justify-center border-2 border-slate-900 bg-white font-bold transition-colors hover:bg-slate-100 ${pad}`}>
        <Spin on={saving} Icon={Save} /> <span>{compact ? "Save" : "Save draft"}</span>
      </button>
      <button type="button" onClick={onDownload} disabled={downloading} data-testid={`${prefix}-download-button`}
        className={`flex items-center justify-center bg-slate-900 font-bold text-white transition-colors hover:bg-slate-700 disabled:opacity-60 ${pad}`}>
        <Spin on={downloading} Icon={Download} /> <span>{compact ? "PNG" : "Download preview"}</span>
      </button>
      <WhatsAppShareButton getSvg={getSvg} name={playerName} label={compact ? "Share" : "Share on WhatsApp"} testId={`${prefix}-whatsapp-share-button`} className={compact ? "min-w-0 flex-col gap-0.5 overflow-hidden px-0.5 py-1.5 text-[11px] leading-none [&>span]:max-w-full [&>span]:break-all" : "px-4 py-2.5 text-sm"} />
      <button type="button" onClick={onAnother} data-testid={`${prefix}-create-another-button`}
        className={`flex items-center justify-center border-2 border-slate-200 bg-white font-bold transition-colors hover:border-slate-900 ${pad}`}>
        <UserPlus className="h-4 w-4" /> <span>{compact ? "New" : "Create another player"}</span>
      </button>
      {!compact && (
        <label className="ml-auto flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-slate-500">
          Cut line <Switch checked={guide} onCheckedChange={onGuide} data-testid={`${prefix}-guide-switch`} />
        </label>
      )}
    </div>
  );
};
